import { c as _c } from "react/compiler-runtime";
import ImageComponent from "@/components/ui/image";
import EmptyCartImg from "@/assets/images/empty_cart_placeholder.svg";
import UniversalButton from "@/components/common/UniversalButton";
import { useRouter } from "next/navigation";
const CartEmptyPlaceholder = t0 => {
  const $ = _c(7);
  const {
    onClose
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== onClose || $[1] !== router) {
    t1 = () => {
      if (onClose) {
        onClose();
      }
      router.push("/");
    };
    $[0] = onClose;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleClick = t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ImageComponent src={EmptyCartImg} alt="empty_cart" width={800} height={500} className="mx-auto block lg:w-60 w-[200px] h-[200px] lg:h-60 object-cover transform hover:scale-105 transition-transform duration-700" quality={100} sizes="(max-width: 1024px) 100vw, 800px" />;
    t3 = <p className="text-[#1E1E1E] font-outfit md:text-xl lg:mb-11 lg:mt-7 mb-7 mt-4 text-sm text-center max-w-[250px]">Psst...Your cart is empty as a Monday morning</p>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== handleClick) {
    t4 = <div className="bg-white flex flex-col justify-center items-center w-full h-full min-h-[calc(100vh-80px)]"><div className="flex justify-center items-center w-full h-full"><div className="flex flex-col justify-center items-center w-full h-full flex-1 -translate-y-16 md:translate-y-0">{t2}{t3}<UniversalButton text="Continue Shopping" onClick={handleClick} classNames="px-4 py-2" /></div></div></div>;
    $[5] = handleClick;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default CartEmptyPlaceholder;